export default [
    {
        path: 'parametrizacao',
        component: () => import(
            /* webpackChunkName: 'farmacia-parametrizacao' */
            '@/views/farmacia/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/index',
        children: [
            {
                name: 'farmacia-parametrizacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-parametrizacao' */
                    '@/views/farmacia/parametrizacao/Form.vue'
                ),
            },
        ],
    },
]